import { createSlice, current } from "@reduxjs/toolkit";
import uuidv4 from "uuid/v4";

const initialState = {
    "id" : uuidv4(),
    "data": []
}
const updatePending = (stateData,data) => {
    let upData =  [...stateData, ...data.data ]
    return upData
}
const removeMsgObject = (stateData,msgId) => {
    return stateData.filter(ele=>ele.msgId !== msgId)
}

const pendindMediaSlice = createSlice({
    name:'pendindMediaSlice',
    initialState,
    reducers:{
        addPendindMedia: (_state,payload)=>{
               return {
                "id" : uuidv4(),
                "data": updatePending(current(_state).data,payload.payload)
               }
        },
        removePendindMedia: (_state,payload)=>{
            return {
             "id" : uuidv4(),
             "data": removeMsgObject(current(_state).data,payload.payload)
            }
     }

    }
});

export default pendindMediaSlice.reducer
export const addPendindMedia = pendindMediaSlice.actions.addPendindMedia
export const removePendindMedia = pendindMediaSlice.actions.removePendindMedia
